import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DomSanitizer } from '@angular/platform-browser';

import { RolesService, Roles, Permissions } from './roles.service';

export enum Types_user {
    USER = 'USER',
    OWNER = 'OWNER',
    TENANT = 'TENANT',
    PROVIDER = 'PROVIDER',
    CUSTOMER = 'CUSTOMER',
    COLLABORATOR = 'COLLABORATOR',
    REQUESTER = 'REQUESTER',
    CLEANER = 'CLEANER',
};

@Injectable({
    providedIn: 'root',
})
export class ProfileService {

  public language : any;

    //UI labels: Initialise the labels on the HTML page
    public field_label = {
        ok: "Ok",
        error_title: "Error!",
        has_no_permission: "User has no permissions to do this action.",
    }
  
  constructor(
		private sanitizer: DomSanitizer,
		public apiService: ApiService,
    public rolesService: RolesService,
	) {
      //Translate the labels on the page
      //this.translateLabels();
	}

/*   translateLabels(){

      if( localStorage.getItem("translations") ) {

          this.language = JSON.parse(localStorage.getItem("translations") || '');

          this.field_label.error_title = this.language['app.error.error_title'];
          this.field_label.has_no_permission = this.language['app.user.has_no_permission'];
          this.field_label.ok = this.language['app.common.ok'];

      }

  }
 */  
  login(loginParams: {}) {

		var body: any;

		body = loginParams;

    return this.apiService.post('/user/login', body).pipe(response => response);
        
  }

  loginByID(id: any) {

		var body: any;

		body = {id: id.toString()};

    return this.apiService.post('/user/loginByID', body).pipe(response => response);
        
  }

  registration(registrationParams: {}) {

		var body: any;

		body = registrationParams;

		return this.apiService.post('/user/register', body).pipe(response => response);

  }

	getProfile( token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/user/profile', body, token).pipe(response => response);

  }

  logOut(token: string) {
		
		var body: any;

		body = {};

		return this.apiService.post('/user/logout', body, token).pipe(response => response);

  }

  updateUser(data: any, token: string) {

    var body: any;

    body = {
          name : data.name,
          phone : data.phone,
          timezone : data.timezone,
          language: data.language, 
          email : data.email,
      };

    return this.apiService.post('/user/update', body, token).pipe(response => response);

  }

  deleteAccount(token: string) {

    var body: any;

    body = {};

    return this.apiService.post('/user/delete', body, token).pipe(response => response);

  }

  forgottenPassword(email: string, url: string, language: string) {

    var body: any;

    body = {email: email, url: url, language: language};

    return this.apiService.post('/user/sendPasswordResetLink', body).pipe(response => response);

  }

  resetPassword(email: string, password: string, password_confirmation: string, token: string) {

    var body: any;

    body = {email: email, password: password, password_confirmation: password_confirmation, token: token};

    return this.apiService.post('/user/resetPassword', body).pipe(response => response);

  }

  changePassword(new_password: string, new_password_confirmation: string, token: string) {

    var body: any;

    body = {new_password: new_password, new_password_confirmation: new_password_confirmation};

    return this.apiService.post('/user/changePassword', body, token).pipe(response => response);

  }

  resendVerificationEmail(email: string, url: string, language: string) {

    var body: any;

    body = {email: email, url: url, language: language};

    return this.apiService.post('/user/sendVerificationWithEmail', body).pipe(response => response);

  }

  resendVerificationEmailLogedIn(url: string, token: string) {

    var body: any;

    body = {url: url};

    return this.apiService.post('/user/sendVerification', body, token).pipe(response => response);

  }

  validateEmail(data: any) {

    var body: any;

    body = {
            token : data.token
            //id : data.id,
            //hash : data.hash,
            //expires : data.expires,
            //signature: data.signature,
        };

    return this.apiService.post('/user/verifyEmail', body).pipe(response => response);

  }
  
  setRole(role: string, token: string) {

		var body: any;

		body = {role: role};

		return this.apiService.post('/roles/setRole', body, token).pipe(response => response);

  }

  sendEmailFromAdmin(id: any, message: string, token: string) {

    var body: any;

    body = {id: id.toString(), message: message};

    return this.apiService.post('/user/sendEmailToUser', body, token).pipe(response => response);

  }

/*   sendNotificationFromAdmin(id: any, message: string, token: string) {

    var body: any;

    body = {id: id.toString(), message: message};

    return this.apiService.post('/user/sendNotificationToUser', body, token).pipe(response => response);

  }
 */
  getUsers(page: number, token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/user/list?page=' + page, body, token).pipe(response => response);

  }

	getUser( id: any, token: string ) {

		var body: any;

		body = {id: id.toString()};

		return this.apiService.get('/user/read', body, token).pipe(response => response);

  }

	getSession( token: string ) {

		var body: any;

		body = {};

		return this.apiService.get('/user/session', body, token).pipe(response => response);

  }

  deleteAvatar(token: string) {

		var body: any;

		body = {};

		return this.apiService.post('/user/deleteAvatar', body, token).pipe(response => response);

  }

  hasAvatar() {

      var avatar = localStorage.getItem("avatar");

      if (!avatar || avatar == "null" || avatar == "") {
          return false;
      }

      return true;
	}

  getInitials(company: boolean = false): string {

    if (!company) {
      var initials = localStorage.getItem("initials") || "";
    } else {
      var initials = localStorage.getItem("company_initials") || "";
    }

/*       if (!company) {
        var name = localStorage.getItem("name") || "";
      } else {
        var name = localStorage.getItem("company_name") || "";
      }

        if (!name) {
            return '';
        }
        const names = name.split(' ');
        let initials = '';
        var i = 0;
        for (const name of names) {
            if (name.length > 0) {
                initials += name[0].toUpperCase();
            }
            i++;
            if (i>3) {
              break;
            }
        }
 */
      return initials;
  }

  getInitialsByName(name: string = ""): string {

      const names = name.split(' ');
      let initials = '';
      var i = 0;

      for (const name of names) {
          if (name.length > 0) {
              initials += name[0].toUpperCase();
          }
          i++;
          if (i>1) {
            break;
          }
      }

      return initials;
  }

  getAvatar() {

    var avatar = localStorage.getItem("avatar");

    if (avatar) {
      return this.sanitizer.bypassSecurityTrustUrl(avatar);
    }
    
    return avatar;
	
  }

  hasCompany() : boolean {
      //return localStorage.getItem('role') === Roles.ADMIN || localStorage.getItem('role') === Roles.PROPERTY_COMPANY_ADMIN || localStorage.getItem('role') === Roles.PROPERTY_COMPANY_AGENT || localStorage.getItem('role') === Roles.CLEANING_COMPANY_ADMIN || localStorage.getItem('role') === Roles.CLEANING_COMPANY_CLEANER;
      const has_company = (localStorage.getItem('company') === "true" ? true : false);
      return has_company;
  }

  hasCompanyLogo() {

      var logo = localStorage.getItem("logo");

      if (!logo || logo == "null" || logo == "") {
          return false;
      }

      return true;
	}

	getCompanyLogo() {
        return localStorage.getItem("logo");
	}

/*   can(permission: Permissions): boolean {

    var permissions = localStorage.getItem("permissions") || "";

    //console.log(permissions, permissions.indexOf(permission));
    return (permissions.indexOf(permission) > -1);

  }
 */  
  canDo(permissions: string, permission: Permissions): boolean {

    //console.log(permissions, permissions.indexOf(permission));
    return (permissions.indexOf(permission) > -1);

  }
  
  getContacts(page: number, token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/user/listContacts?page=' + page, body, token).pipe(response => response);

  }

  getUserRoles(token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/user/listUserRoles', body, token).pipe(response => response);

  }

  getUserInvitations(token: string) {

    var body: any;

    body = {};

    return this.apiService.get('/user/invitations/listNoCompany', body, token).pipe(response => response);

  }

}